import { t } from '../../../../modules/bk/component-property-providers/bk-translations';

class AllocationRoleDataUtil {
    static NA = 'N/A';

    static autoPermitQuestionBlocks = 'autoPermitQuestionBlocks';
    static company = 'company';

    static topicList = 'topicList';
    static registerList = 'registerList';

    static validateRMResponse = (resp) => {
        if (!resp) {
            throw new Error('No Data to parse ');
        }
        if (!resp[AllocationRoleDataUtil.autoPermitQuestionBlocks]) {
            throw new Error(`Not valida data to parse, absence field: "${AllocationRoleDataUtil.autoPermitQuestionBlocks}"`);
        }
        if (!Array.isArray(resp[AllocationRoleDataUtil.autoPermitQuestionBlocks])) {
            throw new Error(`Expect type array for field"${AllocationRoleDataUtil.autoPermitQuestionBlocks}"`);
        }
        if (!resp[AllocationRoleDataUtil.company]) {
            throw new Error(`Not valida data to parse, absence field: "${AllocationRoleDataUtil.company}"`);
        }
        if (!Array.isArray(resp[AllocationRoleDataUtil.company])) {
            throw new Error(`Expect type array for field"${AllocationRoleDataUtil.company}"`);
        }
    };

    static validateCMResponse = (resp) => {
        if (!resp) {
            throw new Error('No Data to parse ');
        }
        if (!resp[AllocationRoleDataUtil.autoPermitQuestionBlocks]) {
            throw new Error(`Not valida data to parse, absence field: "${AllocationRoleDataUtil.autoPermitQuestionBlocks}"`);
        }
        if (!Array.isArray(resp[AllocationRoleDataUtil.autoPermitQuestionBlocks])) {
            throw new Error(`Expect type array for field"${AllocationRoleDataUtil.autoPermitQuestionBlocks}"`);
        }
        if (!resp[AllocationRoleDataUtil.topicList]) {
            throw new Error(`Not valida data to parse, absence field: "${AllocationRoleDataUtil.topicList}"`);
        }
        if (!Array.isArray(resp[AllocationRoleDataUtil.topicList])) {
            throw new Error(`Expect type array for field"${AllocationRoleDataUtil.compatopicListny}"`);
        }
    };

    /**
     * This method is helps to define what type of rendering it would be (simple one with one company
     * on complex one with multiple companies)
     * @returns number
     */
    static getNumberOfCompanies = (resp) => {
        return (resp[AllocationRoleDataUtil.company] || []).length;
    };

    /**
     * Return array of object that needs to be converted into company list
     * @returns [{companyTitle, [{title, options}]} options]
     */
    static parseCMResponse = (resp) => {
        this.validateCMResponse(resp);

        //Categories
        const companyOptions = AllocationRoleDataUtil.parseCompanyBlock(resp);
        companyOptions.title = t('global.category');
        companyOptions.isCompanyOption = true;

        //Tabs
        const registerListOptions = this.parseRegisterList(resp);
        registerListOptions.isRegisterListOption = true;

        //
        const autoPermitQuestionBlocks = resp[AllocationRoleDataUtil.autoPermitQuestionBlocks] || [];
        const autoPermitQuestionOptions = autoPermitQuestionBlocks.map((block) =>
            AllocationRoleDataUtil.parseAutoPermitQuestionBlock(block),
        );
        const companyTitle = '';
        const cid = '-1';

        return {
            companyTitle,
            cid,
            options: [companyOptions, registerListOptions, ...autoPermitQuestionOptions],
        };
    };

    /**
     * Return array of object that needs to be converted into company list
     * @returns [{companyTitle, [{title, options}]} options]
     */
    static parseRMResponse = (data) => {
        this.validateRMResponse(data);

        const autoPermitQuestionBlocks = data[AllocationRoleDataUtil.autoPermitQuestionBlocks] || [];
        const autoPermitQuestionMap = new Map();
        autoPermitQuestionBlocks.forEach((block) => {
            autoPermitQuestionMap.set(block.id, AllocationRoleDataUtil.parseAutoPermitQuestionBlock(block));
        });
        const companies = data[AllocationRoleDataUtil.company] || [];
        const isOneCompany = companies.length === 1;

        return companies.map((company) => {
            const { autoPermitQuestionId, cid, city, companyName } = company;
            const companyTitle = companyName || city ? `${companyName}, ${city}` : '';
            const companyOptions = AllocationRoleDataUtil.parseCompanyBlock(company);
            companyOptions.title = t('global.category');
            companyOptions.isCompanyOption = true;
            const autoPermitQuestionOptions = isOneCompany
                ? Array.from(autoPermitQuestionMap.values())
                : autoPermitQuestionId?.map((apqId) => {
                      const autoPermitQuestionBlock = autoPermitQuestionMap.get(apqId);

                      return { ...autoPermitQuestionBlock };
                  }) || [];

            //Sort company option by id in ascending order
            autoPermitQuestionOptions.sort((a, b) => a?.id - b?.id);

            return {
                companyTitle,
                cid,
                options: [companyOptions, ...autoPermitQuestionOptions],
            };
        });
    };

    static parseAutoPermitQuestionBlock = ({ id, questionText, questionBlockAnswers = [], questionId, blockNumber }) => {
        const title = questionText?.text || AllocationRoleDataUtil.NA;
        const options =
            questionBlockAnswers?.map((item) => ({
                data: item,
                label: item?.answerText?.text || AllocationRoleDataUtil.NA,
                id: item?.answerText?.id || AllocationRoleDataUtil.NA,
            })) || [];

        return { title, options, id, questionId, blockNumber };
    };

    static parseCompanyBlock = ({ city, companyName, topicList }) => {
        const title = `${companyName}, ${city}` || t('clientUser.categories');
        const options =
            topicList?.map((item) => ({
                data: item,
                label: item?.text || AllocationRoleDataUtil.NA,
                id: item?.tid || AllocationRoleDataUtil.NA,
            })) || [];

        return { title, options };
    };

    static parseRegisterList = ({ registerList }) => {
        const title = t('global.tab');
        const options =
            registerList?.map((item) => ({
                data: item,
                label: item?.text || AllocationRoleDataUtil.NA,
                id: item?.tid || AllocationRoleDataUtil.NA,
            })) || [];

        return { title, options };
    };
}

const defineChangeVisibility = (visibilityClass = `hidden`) => {
    const visibilityClassName = visibilityClass;

    return (htmlElement, value) => {
        if (value) {
            htmlElement?.classList?.remove(visibilityClassName);
        } else {
            htmlElement?.classList?.add(visibilityClassName);
        }
    };
};

export { defineChangeVisibility, AllocationRoleDataUtil };
